import React from 'react';
import { useNavigate } from 'react-router';
import "../css/content1.css"

export default function Content1({ item2}) {
  const navigate = useNavigate();




  return (
    <div style={{background:'white'}}>
      <div className="container">
        <div className="row d-flex pt-2 content1 pt-md-4">
          {item2}
          <img src={"/img/iklan1.png"} className="iklan1 ms-auto col-8" alt="" />
        </div>
        <div className=" row mt-2  mt-md-4">
          <div className="col type"
            onClick={(e) => {navigate('/search?category=formal&page=1')}}
          >
            <img src={"/img/formal.png"} width={80} className="ms-auto me-auto d-block" alt="" />
            <p className="font-type">Formal</p>
          </div>
          <div className="col type"
          onClick={(e) => {              
            navigate('/search?category=casual&page=1')
          }} 
          >
            <img src={"/img/casual.png"} width={80} className="ms-auto me-auto d-block" alt="" />
            <p className="font-type">Casual</p>
          </div>
          <div className="col type" onClick={(e) => {              
              navigate('/search?category=sekolah&page=1')
            }}>
            <img src={"/img/school.png"} width={80} className="ms-auto me-auto d-block" alt="" />
            <p className="font-type">School</p>
          </div>
          <div className="col type" onClick={(e) => {              
              navigate('/search?category=olahraga&page=1')
            }}>
            <img src={"/img/sport.png"} width={80} className="ms-auto me-auto d-block" alt="" />
            <p className="font-type">Sport</p>
          </div>
          <div className="col type" onClick={(e) => {              
              navigate('/search?category=religi&page=1')
            }}>
            <img src={"/img/religion.png"} width={80} className="ms-auto me-auto d-block" alt="" />
            <p className="font-type">Religion</p>
          </div>
          <div className="col type"onClick={(e) => {              
              navigate('/search?category=traditional&page=1')
            }}>
            <img src={"/img/traditional.png"} width={80} className="ms-auto me-auto d-block" alt="" />
            <p className="font-type">Traditional</p>
          </div>
          <div className="col type" onClick={(e) => {              
              navigate('/search?category=baby&page=1')
            }}>
            <img src={"/img/baby.png"} width={80} className="ms-auto me-auto d-block" alt="" />
            <p className="font-type">Baby</p>
          </div>

        </div>
      </div></div>

  )
}